<template>
  <div class="box9">
    <pageTitle title="全行业项目库<br/>满足各业务场景运维需求" />
    <span class="tab">
      <a v-for="(item,index) in arr" :key="index" :class="cur==index?'current':''" @click="change(item,index)">{{item.title}}</a>
     
    </span>
   <div class="content">
    <h1>{{arr[cur].h1}}</h1>
    <p>{{arr[cur].p}}</p>
    <img :src="arr[cur].img"  @click="openImg(arr[cur].img)"/>
   </div>
    <div class="previewImage" v-if="isPreview" @click="close">
      <img :src="imgUrl" alt />
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      isPreview:false,
      imgUrl:'',
      cur:0,
     arr:[
    {
      "title": "AI大模型",
      "h1": "基于阿里云平台的AI大模型对话机器人上线部署",
      "p": "本项目涉及Linux服务器安装部署、运维Linux核心命令、阿里云运维、项目上云流程等",
      "img":require("../../../assets/coursePage/linux/box9/part9-1.png")
    },
    {
      "title": "养老行业",
      "h1": "Java智慧养老系统脚本运维实战",
      "p": "本项目涉及Linux网络以及系统服务管理、Shell脚本编程、Java Web项目上线部署实战、Python日志分析与监控告警等",
      "img":require("../../../assets/coursePage/linux/box9/part9-2.png")
    },
    {
      "title": "养老行业",
      "h1": "Java智慧养老系统数据库运维实战",
      "img":require("../../../assets/coursePage/linux/box9/part9-3.png"),
      "p": "本项目涉及数据库服务器搭建、数据迁移、SQL基本操作、MySQL用户与权限管理、MySQL逻辑备份与物理备份、MySQL主从架构、ProxySQL/MyCAT读写分离以及MHA高可用技术等"
    },
    {
      "title": "手机电商",
      "h1": "大型网站系统NiuShop的自动化运维与高可用架构实战",
      "img":require("../../../assets/coursePage/linux/box9/part9-4.png"),
      "p": "本项目涉及Nginx高可用与负载均衡、自动化运维与配置管理、分布式缓存、消息队列、企业级存储与备份、日志分析、CI/CD持续化集成与持续化交付等"
    },
    {
      "title": "新闻资讯",
      "h1": "Java黑马头条自动化运维实战",
      "img":require("../../../assets/coursePage/linux/box9/part9-5.png"),
      "p": "本项目的运维技术点涵盖负载均衡和高可用（使用LVS/HAProxy）实现流量分发），持续集成和自动化部署（通过Jenkins和Shell实现CI/CD），日志与监控（ELK），分布式缓存（Redis），以及消息队列（Kafka）等"
    },
    {
      "title": "PC电商",
      "h1": "基于Kubernetes的黑马商城容器化运维实战",
      "img":require("../../../assets/coursePage/linux/box9/part9-6.png"),
      "p": "本项目的运维技术点涵盖Docker容器化技术、Kubernetes容器编排、Helm包管理、容器监控与容器日志管理、PaaS平台集成等。"
    },
    {
      "title": "教育行业",
      "h1": "云计算运维实战天机学堂",
      "img":require("../../../assets/coursePage/linux/box9/part9-7.png"),
      "p": "本项目涉及SLB高可用集群部署、OSS视频存储与CDN加速、ACK容器化部署、阿里云监控与自动化运维、WAF与DDoS防护等云计算运维核心技术。"
    },
    {
      "title": "政务办公",
      "h1": "国产信创运维实战政务办公系统",
      "img":require("../../../assets/coursePage/linux/box9/part9-8.png"),
      "p": "本项目涉及UOS统信和华为欧拉操作系统、达梦/TiDB/高斯数据库等国产信创技术，以及政务办公系统的运维实战。"
    }
  ]
    };
  },
  computed: {
   
  },
  methods:{
     close() {
      this.isPreview = false;
     
    },
    openImg(img){
      this.imgUrl=img
      this.isPreview = true;
  
    },
    change(item,index){
      this.cur=index
    }
  }
};
</script>

<style lang="less" scoped>
  .previewImage {
    position: fixed;
    top: 0px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 200;
    img {
      width: 100%;
    }
  }
.box9 {
background: linear-gradient( #C5E5FF 0%,#EBF6FF 100%);
  padding: 60px 0 80px;
  .tab{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 48px 14px 8px 34px;
    a{
      width: 154px;
      height: 64px;
      background: #FFFFFF;
      border-radius: 8px;
      display: block;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #4E5969;
      line-height: 64px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin:0 21px 16px 0;
    }
    a.current{
      background: linear-gradient( 313deg, #1F82D7 0%, #65D1FF 100%);
      color: #fff;
    }
  }
  .content{
    background: #FFFFFF;
    border-radius: 20px;
    padding: 32px;
    margin: 0 32px;
    h1{
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #1D2129;
      line-height: 44px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    p{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #4E5969;
      line-height: 40px;
      text-align: left;
      font-style: normal;
      margin: 12px 0 14px;
    }
    img{
      width: 100%;
    }
  }
}
</style>
